module.exports = __webpack_public_path__ + "assets/img/sweep-why.9356fc91.webp";